import { useNavigation } from '@react-navigation/native';
import moment from 'moment';
import React from 'react';
import { useTripInfoState } from 'src/common/hooks/states/useTripInfoState';
import { PrimaryButton, SuspenseFallback } from 'src/components';
import { DatePicker } from 'src/components/layout/DatePicker';
import { TripListHeaderTitle } from './components/TripListHeaderTItle';

const ReturnTripListView = React.lazy(() => import('./ReturnTripListView'));
// const ReturnTripListViewScreen = React.lazy(() => import('./ReturnTripListView'));

const ReturnTripListScreen = () => {
  const { searchInfo, changeReturnDate } = useTripInfoState();
  const navigation = useNavigation();
  const [isVisible, setVisible] = React.useState(false);

  const [date, setDate] = React.useState(searchInfo?.departureDate || new Date());

  const handleChangeDatePress = () => setVisible(true);

  React.useLayoutEffect(() => {
    const headerTitle = () => {
      return (
        <TripListHeaderTitle
          origin={searchInfo?.toLocation}
          destination={searchInfo?.fromLocation}
          date={searchInfo?.returnDate}
          passenger={searchInfo?.passenger}
          onPress={handleChangeDatePress}
        />
      );
    };
    navigation.setOptions({
      headerTitle,
    });
  }, [searchInfo?.returnDate]);

  const handleClose = () => {
    if (searchInfo?.returnDate) {
      setDate(searchInfo.returnDate);
    }
    setVisible(false);
  };

  const handleConfirm = () => {
    setVisible(false);
    changeReturnDate(date);
  };

  return (
    <React.Suspense fallback={<SuspenseFallback />}>
      <ReturnTripListView />
      <DatePicker
        value={date}
        onConfirm={setDate}
        isVisible={isVisible}
        onClose={handleClose}
        button={<PrimaryButton text="confirm" onPress={handleConfirm} />}
        disabledDates={calendarDate => {
          if (calendarDate.isBefore(moment().format('DD MMM, YYYY'))) return true;
          return false;
        }}
      />
    </React.Suspense>
  );
};

export default ReturnTripListScreen;
